import React from 'react'

import Stack from '@mui/material/Stack'

import type { Beat } from '../../../types/CommonBeat'

import { CardError } from './CardError'
import type { CardHeaderMUIProps } from './CardHeaderMUI'
import { CardHeaderMUI } from './CardHeaderMUI'
import { CardLoading } from './CardLoading'
import type { ContentAndDescriptionMUIProps } from './ContentAndDescriptionMUI'
import { ContentAndDescriptionMUI } from './ContentAndDescriptionMUI'

interface BeatCardMUIProps {
  altLoadingText?: string
  asteriskText?: string
  beat: Beat
  button?: React.ReactNode
  children?: React.ReactNode
  contentProps?: Omit<ContentAndDescriptionMUIProps, 'beat'>
  errorText?: string
  feedback?: React.ReactNode
  header?: Omit<CardHeaderMUIProps, 'title'>
  isError?: boolean
  isLoading?: boolean
  isMini?: boolean
}

export const BeatCardMUI = ({
  altLoadingText = '',
  asteriskText,
  beat,
  button = null,
  children,
  contentProps,
  errorText = '',
  feedback,
  header,
  isError = false,
  isLoading = false,
  isMini = false,
}: BeatCardMUIProps) => {
  return (
    <Stack gap={12} sx={{ height: '100%' }}>
      <CardHeaderMUI {...header} isMini={isMini} title={beat.html_title} />
      {isError ? (
        <CardError erroredText={errorText!} />
      ) : (
        <>
          <ContentAndDescriptionMUI
            {...contentProps}
            asteriskText={asteriskText}
            beat={beat}
            isLoading={isLoading}
            isMini={isMini}
          >
            {isLoading ? <CardLoading altLoadingText={altLoadingText} /> : children}
          </ContentAndDescriptionMUI>
          {!isMini && button}
          {feedback}
        </>
      )}
    </Stack>
  )
}
